import React from "react";

interface TitleProps {
  title: string;
  subTitle: string;
  className?: string;
}

const Title: React.FC<TitleProps> = ({ title, subTitle }) => {
  return (
    <>
      <h1 className="uppercase font-sans font-bold text-UDig-gray text-3xl mt-20 print:-mt-10">
        {title}
      </h1>
      <h3 className="w-full mt-2 text-xl font-sans text-sub-title">
        {subTitle}
      </h3>
    </>
  );
};

export default Title;
